import { ProductItem } from "./g-product-item";

class CartDrawerRecommendationsItem extends ProductItem {
  constructor() {
    super();
  }

  async _addToCard(e) {
    await super._addToCard(e);
    this.closest(".js-modal-content-wrapper")?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

customElements.define("cart-drawer-recommendations-item", CartDrawerRecommendationsItem);
